import { render, staticRenderFns } from "./WishIndex.vue?vue&type=template&id=7e101028&scoped=true&"
import script from "./WishIndex.vue?vue&type=script&lang=js&"
export * from "./WishIndex.vue?vue&type=script&lang=js&"
import style0 from "./WishIndex.vue?vue&type=style&index=0&id=7e101028&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e101028",
  null
  
)

export default component.exports